var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKingLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 60,
    viewBox: "0 0 53 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0625 2.8125C29.0625 1.25391 27.8086 0 26.25 0C24.6914 0 23.4375 1.25391 23.4375 2.8125V6.5625H19.6875C18.1289 6.5625 16.875 7.81641 16.875 9.375C16.875 10.9336 18.1289 12.1875 19.6875 12.1875H23.4375V16.875H6.98438C3.12891 16.875 0 20.0039 0 23.8594C0 24.8203 0.199219 25.7695 0.574219 26.6484L6.92578 41.25H13.0547L5.74219 24.3984C5.67188 24.2227 5.625 24.0469 5.625 23.8594C5.625 23.1094 6.23438 22.5 6.98438 22.5H26.25H45.5156C46.2656 22.5 46.875 23.1094 46.875 23.8594C46.875 24.0469 46.8398 24.2344 46.7578 24.3984L39.4336 41.25H45.5625L51.9141 26.6484C52.3008 25.7695 52.4883 24.8203 52.4883 23.8594C52.4883 20.0039 49.3594 16.875 45.5039 16.875H29.0625V12.1875H32.8125C34.3711 12.1875 35.625 10.9336 35.625 9.375C35.625 7.81641 34.3711 6.5625 32.8125 6.5625H29.0625V2.8125ZM11.8594 50.625H40.6406L42.5859 54.375H9.92578L11.8711 50.625H11.8594ZM45.1055 47.0273C44.4609 45.7852 43.1719 45 41.7773 45H10.7227C9.31641 45 8.03906 45.7852 7.39453 47.0273L4.28906 53.0273C3.9375 53.707 3.75 54.457 3.75 55.2188C3.75 57.8672 5.88281 60 8.53125 60H43.9688C46.6055 60 48.75 57.8672 48.75 55.2188C48.75 54.457 48.5625 53.707 48.2109 53.0273L45.1055 47.0273Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKingLogoWhite);
export default __webpack_public_path__ + "static/media/King Logo White.5b27681e9f725a6413737620c4308cd8.svg";
export { ForwardRef as ReactComponent };